module.exports = __webpack_public_path__ + "img/Logo-Sait.8ebee4ed.png";